import { useMemo } from "react";

export const enrichCampaignsWithStatistics = (
  campaigns = {},
  statistics = {}
) => {
  if (!campaigns || !Object.keys(campaigns).length) {
    return campaigns;
  }

  const campaignsStats = statistics?.campaigns || {};
  const enrichedCampaigns = {};

  Object.keys(campaigns).forEach((campaignID) => {
    const campaign = campaigns[campaignID];
    const unifiedCampaign = campaignsStats[campaignID];

    if (!unifiedCampaign) {
      enrichedCampaigns[campaignID] = campaign;
      return;
    }

    const statisticsFormatted = {};
    (unifiedCampaign.platforms || []).forEach((platform) => {
      statisticsFormatted[platform] =
        unifiedCampaign?.levels?.campaign?.maximum?.[platform]?.campaign || {};
    });

    enrichedCampaigns[campaignID] = {
      ...campaign,
      statistics: statisticsFormatted,
    };
  });

  return enrichedCampaigns;
};

export const useEnrichedGlobalReportCampaigns = (campaigns, statistics) =>
  useMemo(
    () => enrichCampaignsWithStatistics(campaigns, statistics),
    [campaigns, statistics]
  );
